// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.ImportDataModelConstants');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  const { isEmpty, isNil } = require('lodash/fp');

  var DestinationGrid = React.createClass({
    render: function () {
      var props = this.props;
      var store = props.store;
      var item = store.dataModelImport;
      var dataSourceGrid = item.importDataModelTenants;
      var TABLE_DEF = constants.TABLE_DESTINATION_DEFINITION;
      var tableClassName = classnames('default-table u_fullHeight u_fullWidth u_noBorder', {
        'hidden' :  isNil(item.selectedDestinationTenantIDs)
      });

      return (
        ! isEmpty(dataSourceGrid) &&
        <div className='u_tableCell'>
          <Panel className='izenda-ImportDataModelDestinationGrid u_borderAll'>
            <Table
              dataSource={dataSourceGrid}
              onSortChange={this.onSortChange}
              sortInfo={item.pageInfo.colSortDirs}
              className={tableClassName}>
              <Column
                {...TABLE_DEF['tenantName']}
                cell={this.renderTenant} />

              <Column
                {...TABLE_DEF['status']}
                cell={this.renderStatus} />

              <Column
                {...TABLE_DEF['action']}
                cell={this.renderActionColumn} />
            </Table>
          </Panel>
        </div>
      );
    },
    /**
     * Render tenant cell
     */
    renderTenant : function (dataRow, key) {
      return <div className="overflow-text">{dataRow[key]}</div>;
    },
    /**
     * Rendern status cell
     */
    renderStatus : function (dataRow, key) {
      var dataRowKey = constants.STATUS_OF_DESTINATION[dataRow[key]];
      var colorSetting = dataRowKey.class;
      return (
        <div>
          <span className={classnames('u_inline', colorSetting)}>{dataRowKey.status}</span>
          <span className={dataRowKey.iconClass} title={constants.VALIDATION_ERROR_TOOLTIP}></span>
        </div>);
    },
    /**
     * Render tenant action column
     */
    renderActionColumn: function (dataRow, key) {
      var props = this.props;
      var localization = props.localization;
      var loader = props.loader;
      var store = props.store;

      var goToTenantMode = function (tenant) {
        loader.startLoading(); 
        store.getAllDestinationConnections(tenant)
        .then(result => {
          store.dataModelImport.setSelectedTenant(tenant, true, result.connections);
        })
        .finally(loader.endLoading.bind(loader));
      };

      return (
        <div>
          <a onClick={goToTenantMode.bind(this, dataRow)}>
            <span title={localization.getText("COPY_MANAGEMENT_LABEL_ADVANCED_SETTINGS")} className='icon-setting' />
          </a>
        </div>
      );
    },

    onSortChange : function (columnKey, sortDir) {
      var item = this.props.item;
      item.onSortChange(columnKey, sortDir);
    }
  });

  module.exports = connect(Dimensions)(DestinationGrid);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/Izenda.DestinationGrid.jsx